import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.sendNotificationConsultation.loading;
export const selectErrorMessage = (state: RootState) =>
  state.sendNotificationConsultation.error;
export const sendNotificationConsultationResponse = (state: RootState) =>
  state.sendNotificationConsultation.sendNotificationConsultationResponse;
